module.exports = __webpack_public_path__ + "static/media/R.3bd7dff2.jpg";